/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/aurora/"

const AURORA: CommunityData = {
  code: "aurora",
  inviteCode: "aurora",
  name: "Aurora",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/aur-030`,
  waitlist: true,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#090e2c",
      hero: {
        desktop: `${S3_PREFIX}web-background-non-member.jpg`,
        mobile: `${S3_PREFIX}web-background-non-member.jpg`,
        style: "bg-[#090e2c]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[92px] h-[74px] sm:w-[140px] sm:h-[112px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['HelveticaNeueMedium'] text-[26px] leading-[110%] text-[#a4bff6]",
      text: "font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-[#a4bff6]",
      button:
        "font-['HelveticaNeueMedium'] text-[14px] leading-[100%] p-4 bg-[#d7dded] text-[#090e2c] cursor-pointer w-fit rounded-lg",
      input: {
        base: "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#0f368a] text-[#a4bff6]",
        border: "#0f368a",
        borderFocus: "#a4bff6",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['HelveticaNeueRegular'] text-[12px] leading-[120%] text-[#a4bff6]",
      skipButton:
        "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] text-[#a4bff6] cursor-pointer",
      modal: {
        container: "bg-[#090e2c] px-[40px] py-[48px]",
        title: "font-['HelveticaNeueMedium'] text-[24px] leading-[110%] text-[#a4bff6] text-center",
        text: "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] text-[#a4bff6] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#a4bff6] bg-[#0f368a] font-['HelveticaNeueMedium'] text-[16px] leading-[120%] text-center",
        otpBorder: "#0f368a",
        otpBorderFocus: "#a4bff6",
      },
    },
    global: {
      counterColor: "#a4bff6",
      werzLogoColor: "#a4bff6",
      logo: {
        src: "https://media.werz.at/community/icon/cmoackai000009kvrloz8logr.jpg?uploadTime=1776929523457&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[140px] h-[112px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#090e2c",
      asideBg: "#090e2c",
      asideStyles: "border-r border-[#a4bff6]",
      contentBg: "#090e2c",
      contentBoxShadow: "!rounded-2xl",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['HelveticaNeueRegular']",
      primaryButton:
        "bg-[#090e2c] border border-[#090e2c] px-[18px] py-[18px] !text-[#ffffff] font-['HelveticaNeueMedium'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#a4bff6",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#a4bff6]",
      item: "font-['CentrionRegular'] text-[18px] text-[#a4bff6] text-center leading-[100%] gap-x-[10px] text-opacity-50 border-b border-[#a4bff6] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#090e2c] !rounded-2xl !pb-8",
      titles: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[26px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#a4bff6] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#a4bff6]",
        sectionTitle:
          "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative rounded-lg overflow-hidden",
          media: "w-full !aspect-square object-cover rounded-lg",
          placeholderMedia: "w-full !aspect-square bg-gray-400 rounded-lg",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[17px] text-left leading-[110%]",
          subtitle:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#a4bff6]",
        sectionTitle:
          "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 relative rounded-lg overflow-hidden",
          media: "w-full !aspect-video object-cover rounded-lg",
          placeholderMedia: "w-full !aspect-video bg-gray-400 rounded-lg",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[17px] text-left leading-[110%]",
          subtitle:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container:
          "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 !border-b border-[#a4bff6] overflow-hidden",
        title: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[24px] text-left leading-[110%]",
        text: "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "rounded-lg",
        sectionTitle:
          "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[26px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/aurora/web-background-non-member.jpg",
      bgMobile: "https://media.werz.at/community-assets/aurora/web-background-non-member.jpg",
      bgColor: "#090e2c",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#090e2c]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#090e2c]",
        name: "text-[#ffffff] font-['HelveticaNeueMedium'] text-[26px] leading-[28.6px] text-center text-center mt-4 mb-1",
        location:
          "font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#a4bff6",
        button:
          "bg-[#d7dded] border border-[#090e2c] rounded-lg px-[12px] py-[12px] text-[#090e2c] font-['HelveticaNeueMedium'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#090e2c] border border-[#090e2c] rounded-2xl text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#090e2c] border border-[#090e2c] rounded-2xl",
          title:
            "font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left text-center mb-1",
          text: "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center",
          button:
            "bg-[#d7dded] border border-[#090e2c] rounded-lg px-[12px] py-[12px] text-[#090e2c] font-['HelveticaNeueMedium'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#090e2c] border border-[#090e2c] rounded-2xl",
          duration:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#a4bff6] font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#a4bff6",
          media: "overflow-hidden m-2 border border-[#090e2c] rounded-lg",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#090e2c] border border-[#090e2c] rounded-2xl",
          name: "text-[#a4bff6] font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#090e2c] border border-[#090e2c] rounded-[8px] text-[#ffffff] font-['HelveticaNeueMedium'] text-[17px] leading-[18.7px] text-center",
          duration:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          location:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#d7dded] border border-[#090e2c] rounded-lg px-[12px] py-[12px] text-[#090e2c] font-['HelveticaNeueMedium'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#090e2c]",
            name: "text-[#a4bff6] font-['HelveticaNeueMedium'] leading-[18.7px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#a4bff6] font-['HelveticaNeueMedium'] leading-[18.7px] text-[14px] text-left",
            link: "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[14px] leading-[16.8px] text-left",
            status:
              "text-[#a4bff6] font-['HelveticaNeueMedium'] leading-[110%] text-[14px] text-left",
            button:
              "bg-[#d7dded] border border-[#090e2c] rounded-lg px-[12px] py-[12px] text-[#090e2c] font-['HelveticaNeueMedium'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#090e2c] border border-[#090e2c] rounded-2xl text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#090e2c] border border-[#090e2c] rounded-2xl",
          name: "text-[#a4bff6] font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#a4bff6",
          created:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#090e2c] rounded-lg",
        },
        seeAllNews:
          "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#090e2c] border border-[#090e2c] rounded-2xl text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#090e2c] border border-[#090e2c] rounded-2xl",
          coverUrl: "overflow-hidden m-2 border border-[#090e2c] rounded-lg",
          duration:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          liveType:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#a4bff6] rounded-full",
          playIconColor: "#090e2c",
          playIconBackgroundColor: "#a4bff6",
          playIconBorderColor: "#090e2c",
          start:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#a4bff6] font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#090e2c] border border-[#090e2c] rounded-2xl text-[#a4bff6] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#090e2c] border border-[#090e2c] rounded-2xl",
          name: "text-[#a4bff6] font-['HelveticaNeueMedium'] leading-[24.2px] text-[16px] text-left",
          triangleIconColor: "#a4bff6",
          circleIcon:
            "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#090e2c] rounded-lg",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#090e2c] !rounded-2xl !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#a4bff6]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0 rounded-lg",
        title: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[26px] text-left leading-[110%]",
        subtitle:
          "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#090e2c] border border-[#090e2c] px-[18px] py-[18px] rounded-lg !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['HelveticaNeueMedium'] !text-[16px] text-left leading-[100%] gap-y-[6px]",
        questions: "text-[14px] text-left leading-[120%] text-[#a4bff6]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#a4bff6]",
        header: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[24px] text-left leading-[110%]",
        text: "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#a4bff6]",
        header: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[24px] text-left leading-[110%]",
        text: "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden rounded-lg gap-y-[10px]",
        mapPinColor: "#a4bff6",
        mapStrokeColor: "#a4bff600",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[24px] text-left leading-[110%]",
        text: "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[24px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#090e2c] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#d7dded] border border-[#090e2c] rounded-lg px-[12px] py-[12px] text-[#090e2c] font-['HelveticaNeueMedium'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#a4bff6] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[17px] text-left leading-[110%] mb-1",
          description:
            "text-[#a4bff6] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[17px] text-left leading-[110%]",
          quantity:
            "text-[#090e2c] font-['HelveticaNeueMedium'] text-[14px] text-left leading-[100%]",
          status:
            "text-[#a4bff6] font-['HelveticaNeueMedium'] text-[17px] text-left leading-[110%]",
          counterContainer:
            "bg-[#d7dded] border border-[#090e2c] rounded-lg px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#d7dded] border border-[#090e2c] rounded-lg px-[12px] py-[12px] text-[#090e2c] font-['HelveticaNeueMedium'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#090e2c",
        },
      },
    },
  },
}

export default AURORA
